import LoginForm from "../components/forms/login.form";
import LoggedOut from "../layouts/loggedOut.layout";
import SingleCardLayout from "../layouts/singleCard.layout";

const Login = () => {
  return (
    <LoggedOut>
      <SingleCardLayout>
        <LoginForm />
      </SingleCardLayout>
    </LoggedOut>
  );
};

export default Login;
